<template>
  <div class="terms-and-conditions">
    <div class="terms-and-conditions__scroller">
      <section
        v-for="(section, index) in sections"
        :key="`section:${index}`"
        class="terms-and-conditions__section"
      >
        <header class="terms-and-conditions__title">
          {{ index + 1 }}. {{ section.title }}
        </header>
        <main>
          <p
            v-for="(paragraph, paragraph_index) in section.paragraphs"
            :key="`paragraph:${paragraph_index}`"
            class="terms-and-conditions__paragraph"
          >
            {{ paragraph }}
          </p>
        </main>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'terms-and-conditions',
    data() {
      return {
        sections: [
          {
            title: 'Dati e documenti',
            paragraphs: [
              'Potremmo richiederti via email dati o documenti aggiuntivi necessari per completare il check-in.',
              'Resta tua responsabilità verificare che i dati dei passeggeri siano corretti e che i documenti di viaggio siano validi per la destinazione.',
            ],
          },
          {
            title: 'Check-in in aeroporto',
            paragraphs: [
              'In alcune casistiche, ad esempio per verifiche documentali, nazionalità specifiche o regole della compagnia, potrebbe essere necessario effettuare il check-in direttamente in aeroporto.',
            ],
          },
          {
            title: 'Esito del servizio',
            paragraphs: [
              'Faremo il possibile per completare il check-in automaticamente, ma l’esito dipende anche dai sistemi e dalle regole operative della compagnia aerea.',
            ],
          },
          {
            title: 'Mancato completamento',
            paragraphs: [
              'Se il check-in automatico non andasse a buon fine, ti avviseremo via email con anticipo per permetterti di procedere autonomamente dal sito della compagnia o in aeroporto.',
            ],
          },
          {
            title: 'Carte di imbarco',
            paragraphs: [
              'Quando il check-in sarà completato, riceverai le carte di imbarco via email. Quando previsto, saranno disponibili anche sull’app della compagnia aerea.',
            ],
          },
          {
            title: 'Assegnazione posti',
            paragraphs: [
              'L’assegnazione dei posti dipende dalle regole della compagnia. I posti già acquistati restano validi; in assenza di scelta posto l’assegnazione può essere automatica o casuale.',
            ],
          },
          {
            title: 'Modifiche operative del volo',
            paragraphs: [
              'In caso di variazioni operative, la richiesta di check-in automatico potrebbe dover essere aggiornata o ricreata.',
            ],
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>
  .terms-and-conditions {
    position: relative;
    font-size: 14px;
    @include scrollbar();
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;

    &__scroller {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    &::after {
      content: '';
      position: sticky;
      display: block;
      left: 0;
      width: 100%;
      height: 50px;
      z-index: 9999;
      pointer-events: none;
      bottom: 0;
      background: linear-gradient(
        180deg,
        transparent 0%,
        $white 100%
      ) !important;
    }

    &__title {
      font-size: 16px;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 5px;
    }

    &__paragraph {
      margin-bottom: 5px;
      margin-left: 17px;
    }
  }
</style>
